//@flow
import React from 'react';
import Shell from '../../Shell/components/Shell.react';

type Props = {
  children?:any,
  pageTitle?:string,
  helloBar?:boolean,
};

/**
 * NOTE:
 * As of 3/2021, the app uses a global header that
 * has handling for both dtc and office pages.
 * As all (or most) office pages use the OfficeShell
 * component, this component is functioning simply
 * as a pass through for the `Shell` component, which
 * renders the global header and children.
 * TODO: remove use of OfficeShell and only use Shell component
 */

const OfficeShellApp = (props:Props) => {
  return (
    <Shell className="office-shell" isOffice={true} {...props}>
      {props.children}
    </Shell>
  );
};

OfficeShellApp.defaultProps = {
  pageTitle: 'Healthy Office Snacks, Snack Delivery Service at Work | NatureBox',
};

export default OfficeShellApp;
